import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class UpcomingEvent extends Component {
    render() {
        console.log(this.props);
        const imgParams = this.props.event.images[0].imgType === "gif" ? "" : "&w=315&h=260";
        const eventurl = this.props.event.images ? this.props.event.images[0].url + imgParams : "";
        return (
            <div>
              {/* Upcoming/Past and Event/Exhibition
              <div className="hor">
                <span className={this.props.activeHor === "future" ? "future activeLink" : "future"}>Upcoming</span> /
                <span className={this.props.activeHor === "past" ? "past activeLink" : "past"}>Past</span>
              </div>

              <div className="ver">
                <span className={this.props.activeVer === "exhibition" ? "exhibition activeLink" : "exhibition"}>Exhibitions</span> /
                <span className={this.props.activeVer === "event" ? "event activeLink" : "event"}>Events</span>
              </div>
               */}
              <img src={eventurl} alt={this.props.event.title}/>
              <Link to={"/space/" + this.props.event.slug}>{this.props.event.title}</Link>
            </div>
        );
    }
}

export default UpcomingEvent;


// WEBPACK FOOTER //
// ./src/components/Landing/UpcomingEvent.js